import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/app/staging/app/(with-metadata)/(main)/MainLayoutClient.tsx");
